import 'url-search-params-polyfill'
import React from 'react'
import {
	Button,
	MenuButton,
	MenuItem,
	HelpButton,
	IconDownTriangle,
} from '@wf-wfria/pioneer-core'
import { config } from '../../package.json'
import { FormattedMessage } from 'react-intl'
import fordProLogo from '../fordpro_lease_white.png'
import {
	WFINFOLEASE,
	PLINFOLEASE,
	WFORMS,
	SBA,
	LGMTBOB,
	ONBOARD,
	RFI,
	DOCEX,
	RICOH,
	DLO,
	COBO,
	BOB,
	EASYCONNECT,
	OCRANA,
	OCRAEMEA,
	OCRAANZ,
	FORDPRO,
} from '../businessSegmentBrandIds'

export function Header({
	mode,
	auth,
	productName,
	hideNavItems,
	onShowFeedback,
	locale,
	showLanguageDropDown,
	intl,
	onChangeLanguageDropDown,
}) {
	return (
		<header className="Header">
			<div>
				<span className="HeaderLogo">
					<HeaderLogoText mode={mode} intl={intl} />
				</span>
				<span className="HeaderNavigationMenu">
					<NonCCHeaderItems
						mode={mode}
						auth={auth}
						hideNavItems={hideNavItems}
						onShowFeedback={onShowFeedback}
						locale={locale}
						showLanguageDropDown={showLanguageDropDown}
						intl={intl}
						onChangeLanguageDropDown={onChangeLanguageDropDown}
					/>
				</span>
			</div>
			<p className="wf-text6 LendingCenter">{`Welcome to ${productName}`}</p>
			{mode === WFINFOLEASE && (
				<p className="wf-text6 AccountCenter">
					<FormattedMessage id="wca-form.sign-on.form-header.label-wb" />
				</p>
			)}
			{mode === FORDPRO && (
				<p className="wf-text6 AccountCenter">
					<FormattedMessage id="wca-form.sign-on.form-header.label-fordpro" />
				</p>
			)}
		</header>
	)
}
export function getRedirectUrl() {
	return document.URL
}

export function HeaderLogoText({ mode, intl }) {
	switch (mode) {
		case FORDPRO:
			return (
				<a href={getRedirectUrl()} title="Ford Pro">
					<img
						src={fordProLogo}
						alt="Ford Pro Logo"
						style={{ maxHeight: '40px', position: 'relative', top: '-16px' }}
					/>
				</a>
			)
		case RICOH:
			return (
				<a
					href={getRedirectUrl()}
					title={intl.formatMessage({
						id: 'header.appefmyaccountsricoh.logo-title',
					})}
				>
					<span
						className="header-icon"
						aria-label={intl.formatMessage({
							id: 'header.appefmyaccountsricoh.logo-title',
						})}
						role="img"
					/>
				</a>
			)
		case WFINFOLEASE:
			return (
				<a
					href={getRedirectUrl()}
					title={intl.formatMessage({
						id: 'header.appefmyaccounts.logo-title',
					})}
				>
					<img
						src="https://www17.wellsfargomedia.com/assets/images/rwd/wf_logo_220x23.png"
						alt="Wells Fargo Home Page"
					/>
				</a>
			)

		case PLINFOLEASE:
			return (
				<a
					href={getRedirectUrl()}
					title={intl.formatMessage({
						id: 'header.appefmyaccountspl.logo-title',
					})}
				>
					<span
						className="header-icon"
						aria-label={intl.formatMessage({
							id: 'header.appefmyaccountspl.logo-title',
						})}
						role="img"
					/>
				</a>
			)

		case DOCEX:
		case WFORMS:
		case RFI:
		case SBA:
		case LGMTBOB:
		case ONBOARD:
		case DLO:
		case COBO:
		case EASYCONNECT:
			return (
				<a
					href={getRedirectUrl()}
					title={intl.formatMessage({
						id: 'header.appefmyaccountscc.logo-title',
					})}
				>
					<span
						className="header-icon"
						aria-label={intl.formatMessage({
							id: 'header.appefmyaccountscc.logo-title',
						})}
						role="img"
					/>
				</a>
			)
		default:
			return null
	}
}

// todo rename hideNavItems to show
export function NonCCHeaderItems({
	hideNavItems,
	onShowFeedback,
	locale,
	mode,
	auth,
	showLanguageDropDown,
	intl,
	onChangeLanguageDropDown,
}) {
	if (hideNavItems === true) {
		return null
	}
	if (mode === OCRANA || mode === OCRAEMEA || mode === OCRAANZ) {
		return null
	}
	return (
		<ul className="HeaderMenuList">
			<Feedback onShowFeedback={onShowFeedback} mode={mode} auth={auth} />
			<Support
				mode={mode}
				intl={intl}
				showLanguageDropDown={showLanguageDropDown}
			/>
			<LanguageDropDown
				locale={locale}
				showLanguageDropDown={showLanguageDropDown}
				mode={mode}
				intl={intl}
				onChangeLanguageDropDown={onChangeLanguageDropDown}
			/>
		</ul>
	)
}

/* Feedback Change */

export function Feedback({ onShowFeedback, mode, auth }) {
	function onClick() {
		onShowFeedback()
	}

	return (
		<li className="HeaderFeedbackButton">
			<Button
				onClick={onClick}
				className="wf-button wf-button--simple HeaderFeedbackButton"
			>
				<FormattedMessage id="wca-form.button.header-feedback.label" />
			</Button>
		</li>
	)
}

export function ContactNumber({ mode, showLanguageDropDown }) {
	if (showLanguageDropDown) {
		return <FormattedMessage id={`support.${mode}.contact-canada-text`} />
	}
	return <FormattedMessage id={`support.${mode}.contact-us-text`} />
}

/* Support Change */
function getHeaderSupportText(mode, showLanguageDropDown) {
	if (mode === WFINFOLEASE) {
		return (
			<div className="HeaderSupportToggle">
				<span>
					<section>
						<div>
							<ContactNumber
								mode={mode}
								showLanguageDropDown={showLanguageDropDown}
							/>
						</div>
						<div>
							<FormattedMessage id="support.appefmyaccounts.monday-friday-text" />
							<FormattedMessage id="support.appefmyaccounts.hours-of-operation-text" />
						</div>
					</section>
				</span>
			</div>
		)
	} else if (mode === PLINFOLEASE || mode === FORDPRO) {
		return (
			<div className="HeaderSupportToggle">
				<span>
					<section>
						<div>
							<ContactNumber
								mode={mode}
								showLanguageDropDown={showLanguageDropDown}
							/>
						</div>
						<div>
							<FormattedMessage id="support.appefmyaccountspl.monday-friday-text" />
							<FormattedMessage id="support.appefmyaccountspl.hours-of-operation-text" />
						</div>
					</section>
				</span>
			</div>
		)
	} else {
		// default is Ricoh
		return (
			<div className="HeaderSupportToggle">
				<span>
					<section>
						<div>
							<ContactNumber
								mode={mode}
								showLanguageDropDown={showLanguageDropDown}
							/>
						</div>
						<div>
							<FormattedMessage id="support.appefmyaccountsricoh.monday-friday-text" />
							<FormattedMessage id="support.appefmyaccountsricoh.hours-of-operation-text" />
						</div>
					</section>
				</span>
			</div>
		)
	}
}

export function Support({ mode, intl, showLanguageDropDown }) {
	const headerSupport = getHeaderSupportText(mode, showLanguageDropDown)
	const supportLabel = intl.formatMessage({
		id: 'wca-form.button.header-support.label',
	})
	if (
		mode === RFI ||
		mode === SBA ||
		mode === EASYCONNECT ||
		mode === ONBOARD ||
		mode === DOCEX ||
		mode === WFORMS ||
		mode === LGMTBOB ||
		mode === DLO ||
		mode === COBO
	) {
		return null
	}
	return (
		<li className="HeaderSupport">
			<HelpButton
				kind="chromeless"
				aria-label={supportLabel}
				helpBody={headerSupport}
				rightIcon={
					<IconDownTriangle theme="inverse" size="xsmall" decorative />
				}
			>
				{supportLabel}
			</HelpButton>
		</li>
	)
}
/* Support Change */

/*Language Change */

// todo never use `null` refactor to use empty string
export function getLanguageMenuListsValues(url) {
	const params = new URLSearchParams(url)
	if (params.has('mode') && params.get('mode') === 'canada') {
		if (params.has('locale') && params.get('locale') === 'en') {
			params.delete('locale')
			params.append('locale', 'fr')
			const menuItemValue = '?' + params.toString()
			return menuItemValue
		} else if (params.has('locale') && params.get('locale') === 'fr') {
			params.delete('locale')
			params.append('locale', 'en')
			const menuItemValue = '?' + params.toString()
			return menuItemValue
		} else {
			params.append('locale', 'fr')
			const menuItemValue = '?' + params.toString()
			return menuItemValue
		}
	} else {
		return null
	}
}

// todo update messageIds by locale not JSX output
// todo `wca-form.button.us-users-sign-on-french.label` shld be canada not us
export function LanguageMenuList({
	locale,
	intl,
	menuItemValue,
	onChangeLanguageDropDown,
}) {
	function onSelectedValueChange(event) {
		onChangeLanguageDropDown(event)
	}

	if (locale === 'en') {
		const label = intl.formatMessage({
			id: 'wca-form.button.canada-users-sign-on-english.label',
		})
		const menuItemLabel = intl.formatMessage({
			id: 'wca-form.button.us-users-sign-on-french.label',
		})

		const menuList = <MenuItem value={menuItemValue}>{menuItemLabel}</MenuItem>

		return (
			<li className="HeaderLanguage">
				<MenuButton
					kind="simple"
					rightIcon={
						<IconDownTriangle theme="inverse" size="xsmall" decorative />
					}
					label={label}
					onSelectedValueChange={onSelectedValueChange}
				>
					{menuList}
				</MenuButton>
			</li>
		)
	} else {
		const label = intl.formatMessage({
			id: 'wca-form.button.us-users-sign-on-french.label',
		})
		const menuItemLabel = intl.formatMessage({
			id: 'wca-form.button.canada-users-sign-on-english.label',
		})

		const menuList = <MenuItem value={menuItemValue}>{menuItemLabel}</MenuItem>
		return (
			<li className="HeaderLanguage">
				<MenuButton
					kind="simple"
					rightIcon={
						<IconDownTriangle theme="inverse" size="xsmall" decorative />
					}
					label={label}
					onSelectedValueChange={onSelectedValueChange}
				>
					{menuList}
				</MenuButton>
			</li>
		)
	}
}

// todo rename LanguageDropDown to LanguageDropdown
// todo rename showLanguageDropDown to show
// todo refactor to extract show based on mode to container or reducer
export function LanguageDropDown({
	locale,
	showLanguageDropDown,
	mode,
	intl,
	onChangeLanguageDropDown,
}) {
	if (showLanguageDropDown) {
		const url = window.location.search
		const menuItemValue = getLanguageMenuListsValues(url)
		switch (mode) {
			case WFINFOLEASE:
			case PLINFOLEASE:
			case FORDPRO:
				return (
					<LanguageMenuList
						locale={locale}
						intl={intl}
						menuItemValue={menuItemValue}
						onChangeLanguageDropDown={onChangeLanguageDropDown}
					/>
				)
			default:
				return null
		}
	} else {
		return null
	}
}
/*Language Change */
